// extracted by mini-css-extract-plugin
module.exports = {"wrap":"MenuBlock_wrap__UgjtN"};